import React from "react";
import { Link } from "react-router-dom";
import { Shield } from "./header";

const ArrowRight = ({ size = 14 }: { size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none">
    <path d="M1 7h12m-4-4 4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

function FooterCol({ title, items }: { title: string; items: { label: string; href: string; external?: boolean }[] }) {
  return (
    <div>
      <div style={{
        fontFamily: "var(--mono)",
        fontSize: 11,
        letterSpacing: "0.15em",
        textTransform: "uppercase",
        color: "var(--gold)",
        marginBottom: 20,
      }}>
        {title}
      </div>
      <ul style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 10, fontSize: 15 }}>
        {items.map((item) => (
          <li key={item.label}>
            {item.external ? (
              <a
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--cream)", opacity: 0.85, textDecoration: "none" }}
              >
                {item.label}
              </a>
            ) : (
              <Link to={item.href} style={{ color: "var(--cream)", opacity: 0.85, textDecoration: "none" }}>
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function Footer(_props: { isMobile?: boolean; light?: boolean }) {
  return (
    <footer style={{
      background: "var(--maroon-deep)",
      color: "var(--cream)",
      padding: "80px 64px 40px",
    }}>
      {/* Top grid */}
      <div style={{
        display: "grid",
        gridTemplateColumns: "1.4fr 1fr 1fr 1fr",
        gap: 64,
        marginBottom: 80,
      }}
        className="pte-footer-grid"
      >
        {/* Brand column */}
        <div>
          <div style={{ marginBottom: 24 }}>
            <Shield />
          </div>
          <p style={{ fontSize: 14, opacity: 0.7, lineHeight: 1.6, maxWidth: 320, color: "var(--cream)" }}>
            Friendlier, more personal title &amp; escrow services for the District and Maryland — for over three decades.
          </p>
        </div>

        <FooterCol
          title="Services"
          items={[
            { label: "Title insurance", href: "https://fntic.com/whatistitle.aspx", external: true },
            { label: "Settlement", href: "/contact" },
            { label: "Title rate estimator", href: "https://ratecalculator.fnf.com/", external: true },
            { label: "My Home Approved", href: "https://www.princegeorgescountymd.gov/2964/First-Time-Home-Buyer-Assistance-Program", external: true },
          ]}
        />

        <FooterCol
          title="Company"
          items={[
            { label: "Our team", href: "/our-team" },
            { label: "Resources", href: "https://fntic.com/whatistitle.aspx", external: true },
            { label: "Contact", href: "/contact" },
            { label: "Secure portal", href: "/secure-portal" },
          ]}
        />

        {/* Contact column */}
        <div>
          <div style={{
            fontFamily: "var(--mono)",
            fontSize: 11,
            letterSpacing: "0.15em",
            textTransform: "uppercase",
            color: "var(--gold)",
            marginBottom: 20,
          }}>
            Visit us
          </div>
          <div style={{ fontSize: 15, lineHeight: 1.7, color: "var(--cream)" }}>
            7701 Greenbelt Rd, Suite 513<br />
            Greenbelt, MD 20770<br />
            <a href="tel:3015139090" style={{ opacity: 0.7, color: "inherit", textDecoration: "none" }}>(301) 513-9090</a><br />
            <a href="mailto:settle@preferredtitle.us" style={{ opacity: 0.7, color: "inherit", textDecoration: "none" }}>settle@preferredtitle.us</a>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div style={{
        borderTop: "1px solid rgba(246,237,228,.15)",
        paddingTop: 24,
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
        fontSize: 13,
        opacity: 0.55,
        color: "var(--cream)",
      }}>
        <div>© {new Date().getFullYear()} Preferred Title &amp; Escrow, Inc. All rights reserved.</div>
        <div style={{ display: "flex", gap: 24, flexWrap: "wrap" }}>
          <a href="https://www.fntic.com/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>
            Underwritten by Fidelity National Title
          </a>
          <Link to="/contact" style={{ color: "inherit", textDecoration: "none" }}>Privacy</Link>
        </div>
      </div>

      <style>{`
        .pte-footer-grid { grid-template-columns: 1.4fr 1fr 1fr 1fr; }
        @media (max-width: 768px) {
          footer { padding: 48px 20px 100px !important; }
          .pte-footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
        }
      `}</style>
    </footer>
  );
}
